/**
 * 项目报价审计实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
 */

import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Modal,
    Row,
    message,
    Tabs,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, UjoinParams, winHeight, winWidth } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

import OfferList from './OfferList';

const MODULENAME_URL = CNF.navItems[0].submenu[2].url;

const OfferAuditEntity = (props) => {
    const { open, setOpen, record, refresh } = props;

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [offerSorts, setOfferSorts] = useState([]);
    const [offerLists, setOfferLists] = useState([]);
    const [sortNumber, setSortNumber] = useState(1);
    const [auditedAmount, setAuditedAmount] = useState(0);
    const [auditedTaxAmount, setAuditedTaxAmount] = useState(0);

    const cancel = () => {
        setOpen(false);
        setLoading(false);
        setOfferSorts([]);
        setOfferLists([]);
        setSortNumber(1);
        setAuditedAmount(0);
        setAuditedTaxAmount(0);
    }

    useEffect(() => {
        /**
         * 获取报价分类
         * @param {*} record 
         */
        const getOfferSorts = (record) => {
            const params = {
                project_offer_ulid: record.key,
            };
            $.ajax({
                url: `${CNF.api}projects/offers/sorts${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setOfferSorts(data.dat);
                        } else {
                            setOfferSorts([]);
                        }
                    }
                }
            })
        }

        /**
         * 获取报价清单
         * @param {*} record 
         */
        const getOfferLists = (record) => {
            const params = {
                project_offer_ulid: record.key,
            };
            $.ajax({
                url: `${CNF.api}projects/offers/lists${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            let ofLists = [];
                            //  审定数量、审定单价、审定金额、审定税点、审定税费默认使用报价的数据
                            for (let i = 0; i < data.dat.length; i++) {
                                let item = data.dat[i];
                                item.audited_count = parseFloat(item.audited_count) > 0 ? item.audited_count : item.count;
                                item.audited_price = parseFloat(item.audited_price) > 0 ? item.audited_price : item.price;
                                item.audited_amount = parseFloat(item.audited_amount) > 0 ? item.audited_amount : item.amount;
                                item.audited_tax_point = parseFloat(item.audited_tax_point) > 0 ? item.audited_tax_point : item.tax_point;
                                item.audited_tax_amount = parseFloat(item.audited_tax_amount) > 0 ? item.audited_tax_amount : item.tax_amount;
                                ofLists.push(item);
                            }
                            setOfferLists(ofLists);
                        } else {
                            setOfferLists([]);
                        }
                    }
                }
            })
        }

        // 修改初始化
        if (record && open) {
            getOfferSorts(record);
            getOfferLists(record);
            setAuditedAmount(record.amount);
            setAuditedTaxAmount(record.tax_amount);
        }
    }, [open, record]);

    /**
     * 汇总金额
     * @param {*} ofLists 
     */
    const sumAmount = (ofLists) => {
        let auditedAmount = 0;     // 审定金额合计
        let auditedTaxAmount = 0;  // 审定税费合计
        for (let i = 0; i < ofLists.length; i++) {
            auditedAmount += parseFloat(ofLists[i].audited_amount);
            auditedTaxAmount += parseFloat(ofLists[i].audited_tax_amount);
        }
        let soLists = [];
        for (let i = 0; i < offerSorts.length; i++) {
            let sortAmount = 0;     // 审定金额小计；
            let sortTaxAmount = 0;  // 审定税费小计；
            let sortItem = offerSorts[i];
            for (let j = 0; j < ofLists.length; j++) {
                let listItem = ofLists[j];
                if (sortItem.number === listItem.sort_number) {
                    sortAmount += parseFloat(listItem.audited_amount);
                    sortTaxAmount += parseFloat(listItem.audited_tax_amount);
                }
            }
            let item = offerSorts[i];
            item.audited_amount = sortAmount;
            item.audited_tax_amount = sortTaxAmount;
            soLists.push(item);
        }
        setOfferLists(ofLists);
        setAuditedAmount(auditedAmount.toFixed(CNF.DPL));
        setAuditedTaxAmount(auditedTaxAmount.toFixed(CNF.DPL));
    }

    /**
     * 修改数量
     * @param {*} record 
     * @param {*} count 
     */
    const updateCount = (record, count) => {
        count = count === null ? 0 : count;
        let ofLists = [];
        for (let i = 0; i < offerLists.length; i++) {
            let item = offerLists[i];
            if (item.number === record.number && item.sort_number === sortNumber) {
                //  修改数量
                item.audited_count = count;
                item.audited_amount = (parseFloat(item.audited_count) * parseFloat(item.audited_price)).toFixed(CNF.DPL);
                item.audited_tax_amount = (parseFloat(item.audited_count) * parseFloat(item.audited_price) * parseFloat(item.audited_tax_point) / 100).toFixed(CNF.DPL);
            }
            ofLists.push(item)
        }
        setOfferLists(ofLists);
        sumAmount(ofLists);
    }

    /**
     * 修改单价
     * @param {*} record 
     * @param {*} count
     */
    const updatePrice = (record, price) => {
        price = price === null ? 0 : price;
        let ofLists = [];
        for (let i = 0; i < offerLists.length; i++) {
            let item = offerLists[i]
            if (item.number === record.number && item.sort_number === sortNumber) {
                //  修改数量
                item.audited_price = price;
                item.audited_amount = (parseFloat(item.audited_count) * parseFloat(item.audited_price)).toFixed(CNF.DPL);
                item.audited_tax_amount = (parseFloat(item.audited_count) * parseFloat(item.audited_price) * parseFloat(item.audited_tax_point) / 100).toFixed(CNF.DPL);
            }
            ofLists.push(item)
        }
        setOfferLists(ofLists);
        sumAmount(ofLists);
    }

    /**
     * 修改税点
     * @param {*} record 
     * @param {*} value
     */
    const updateTaxPoint = (record, value) => {
        value = value === null ? 0 : value;
        let ofLists = [];
        for (let i = 0; i < offerLists.length; i++) {
            let item = offerLists[i];
            if (item.number === record.number && item.sort_number === sortNumber) {
                //  修改税点
                item.audited_tax_point = value;
                item.audited_tax_amount = (parseFloat(item.audited_count) * parseFloat(item.audited_price) * parseFloat(item.audited_tax_point) / 100).toFixed(CNF.DPL);
            }
            ofLists.push(item)
        }
        setOfferLists(ofLists);
        sumAmount(ofLists);
    }

    const ok = () => {
        setLoading(true);

        // 执行审核
        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                action: CNF.actionName.AUDIT,
                name: props.record?.name,
                offer_lists: offerLists.map((item) => ({
                    key: item.key,
                    audited_count: item.audited_count,
                    audited_price: item.audited_price,
                    audited_amount: item.audited_amount,
                    audited_tax_point: item.audited_tax_point,
                    audited_tax_amount: item.audited_tax_amount,
                })),
                audited_amount: auditedAmount,
                audited_tax_amount: auditedTaxAmount,
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))
    };

    return (
        <ConfigProvider
            theme={{
                components: {
                    Tabs: {
                        horizontalItemPadding: '0 10px',
                        cardPaddingSM: '3px 10px',
                    },
                },
            }}
        >
            {contextHolder}
            <Modal
                width={winWidth > 200 ? winWidth - 200 : winWidth}
                height={winHeight}
                title={'报价审核-' + props.record?.name}
                style={{ top: 0, left: 100 }}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确定'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Tabs
                        hideAdd
                        size={'small'}
                        style={{ width: '100%' }}
                        onChange={(key) => setSortNumber(key)}
                        activeKey={sortNumber}
                        type='editable-card'
                        items={offerSorts.map((item) => {
                            /**
                             * 报价默认只有一个分类，名称为“一、项目整体报价”，支持修改，若只有一个分类，打印时报价不分类
                             * 根据报价分类，重新封装Tags列表
                            */
                            return {
                                closable: item.number === 1 ? false : true,
                                key: item.number,
                                label: item.name,
                                children: <OfferList
                                    btnLists={props.btnLists}
                                    dataLists={offerLists.filter(item => item.sort_number === sortNumber)}
                                    offerSorts={offerSorts}
                                    sortNumber={sortNumber}
                                    updateCount={updateCount}
                                    updatePrice={updatePrice}
                                    updateTaxPoint={updateTaxPoint}
                                    amount={auditedAmount}
                                    taxAmount={auditedTaxAmount}
                                    operation={CNF.actionName.AUDIT}
                                />
                            }
                        })}
                        defaultActiveKey={1}
                    />
                </Row>
            </Modal>
        </ConfigProvider>
    );
}

export default OfferAuditEntity